<template>
  <v-locale-provider v-if="!!app_loaded" :rtl="isAppRtl">
    <v-app :style="`direction: ${isAppRtl ? 'rtl' : 'ltr'}; --v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <SnackBar
        v-for="ntf of notification.getNotifications"
        :id="ntf.id"
        :key="'sn' + ntf.id"
        :show="ntf.show"
        :location="ntf.location"
        :icon="ntf.icon"
        :message="ntf.message"
        :timeout="ntf.timeout"
        :type="ntf.type"
        :color="ntf.color" />
      <BlankLayout v-if="isBlankLayout" />
      <DefaultLayout v-else />
    </v-app>
  </v-locale-provider>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import DefaultLayout from './layouts/DefaultLayout.vue';
import BlankLayout from './layouts/BlankLayout.vue';
import { useSnackBarStore } from './stores/snackbar';
import { useAccountStore } from './stores/account';
import { useThemeConfig } from './composables/useThemeConfig';
import { useTheme } from 'vuetify';
import { lsGet, lsRemove } from './helpers/localStorageHelper';
import SnackBar from './components/widgets/SnackBar.vue';
import { ref } from 'vue';
import { onMounted } from 'vue';
import { hexToRgb } from './helpers/utils';

const route = useRoute();
const router = useRouter();
const notification = useSnackBarStore();
const accountStore = useAccountStore();
const app_loaded = ref(false);

const { syncVuetifyThemeWithTheme, isAppRtl } = useThemeConfig();

const { global } = useTheme();
const pagePath = computed(() => router.currentRoute._value.path);
const isBlankLayout = computed(
  () => !accountStore.isLoggedIn || ['/login', '/forgot-password', '/reset-password', '/404', '/not-found'].includes(pagePath.value),
);
// ℹ️ Sync current theme with initial loader theme
syncVuetifyThemeWithTheme();

onMounted(() => {
  getAccountInfo();
});

async function getAccountInfo() {
  if (lsGet('accessToken')) {
    await accountStore
      .getInfo()
      .then(response => {
        window.app_configs = response.data.app_configs;
        accountStore.afterloggedin(response);
      })
      .catch(error => {
        notification.responseError(error, () => {
          setTimeout(() => {
            lsRemove(['accessToken', 'logged', 'userData', 'permission']);
            router.push('/login');
          }, 500);
        });
      })
      .finally(() => {
        app_loaded.value = true;
        document.getElementById('loading-bg')?.remove();
      });
  } else {
    app_loaded.value = true;
    router.replace(route.query.to ? String(route.query.to) : '/login');
  }
}
</script>
